import { readPortalSession as readSession, savePortalSession } from '../../utils/portalSession';
import { Base_url } from '../../utils/Base_url';
export { readPortalSession as readSession } from '../../utils/portalSession';
export const blogSite = (
  process.env.REACT_APP_BLOG_SITE_URL || 'https://www.welcomehabibitrading.com'
).replace(/\/$/, '');
export async function blogApi(path, options = {}) {
  const { method = 'GET', body, signal } = options;
  const form = body instanceof FormData;
  const token = readSession()?.token;
  const response = await fetch(`${Base_url}/v1/blog${path}`, {
    method,
    signal,
    headers: {
      ...(form ? {} : { 'Content-Type': 'application/json' }),
      ...(token ? { Authorization: `Bearer ${token}` } : {})
    },
    ...(body ? { body: form ? body : JSON.stringify(body) } : {})
  });
  const data = response.status === 204 ? null : await response.json().catch(() => ({}));
  if (!response.ok) {
    if (response.status === 401 && token === readSession()?.token) {
      savePortalSession(null);
      window.dispatchEvent(new Event('blog-session-expired'));
    }
    throw new Error(data?.message || 'The request could not be completed. Please try again.');
  }
  return data;
}
export async function uploadBlogImage(file) {
  if (
    !file ||
    !['image/jpeg', 'image/png', 'image/webp'].includes(file.type) ||
    file.size > 8 * 1024 * 1024
  )
    throw new Error('Choose a JPEG, PNG or WebP image up to 8 MB.');
  const body = new FormData();
  body.append('image', file);
  return blogApi('/admin/upload', { method: 'POST', body });
}
